module.exports = __webpack_public_path__ + "img/lang-open.95a1edf.webp";